
import React from 'react';

export const LEGAL_CONTENT = {
  terms: {
    title: "Termos de Uso",
    text: (
      <div className="space-y-4 text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
        <p className="font-bold text-slate-900 dark:text-slate-100">Equilibra Finanças</p>
        <p>Última atualização: 22 de fevereiro de 2026</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">1. Aceitação dos Termos</p>
        <p>Ao utilizar o Equilibra Finanças, o usuário declara estar ciente e de acordo com estes Termos de Uso.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">2. Natureza do Serviço</p>
        <p>O Equilibra Finanças é uma ferramenta de organização financeira pessoal.</p>
        <p>Não oferecemos:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>Consultoria financeira</li>
          <li>Recomendação de investimentos</li>
          <li>Serviços bancários</li>
        </ul>

        <p className="font-bold text-slate-900 dark:text-slate-100">3. Responsabilidades do Usuário</p>
        <p>O usuário é responsável por:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>Manter segura sua conta Google</li>
          <li>Guardar sua chave criptográfica (Chave Mestra)</li>
          <li>Manter suas credenciais protegidas</li>
          <li>Conferir a veracidade dos dados inseridos</li>
        </ul>

        <p className="font-bold text-slate-900 dark:text-slate-100">4. Disponibilidade do Serviço</p>
        <p>O funcionamento do aplicativo depende de serviços de terceiros, incluindo:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>Serviços da Google (Sheets, Drive, Calendar)</li>
          <li>Serviços do Supabase</li>
          <li>Conectividade com a internet</li>
        </ul>
        <p>O desenvolvedor não se responsabiliza por indisponibilidades causadas por esses terceiros.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">5. Cancelamento e Direito de Arrependimento (7 Dias)</p>
        <p>O usuário poderá exercer o direito de arrependimento no prazo de até 7 (sete) dias corridos a contar da data da contratação do aplicativo realizada online.</p>
        <p>Dentro desse prazo, o usuário poderá solicitar o cancelamento com direito ao reembolso integral do valor pago.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">5.1 Como Solicitar o Cancelamento</p>
        <p>Para exercer o direito de arrependimento, o usuário deverá enviar solicitação para o e-mail oficial: <code>suporte@equilibra.com</code> dentro do prazo legal de 7 (sete) dias corridos.</p>
        <p>Após confirmação da elegibilidade, o reembolso será processado utilizando o mesmo meio de pagamento da transação original, respeitando os prazos operacionais do intermediador financeiro (ex: Mercado Pago).</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">5.2 Cancelamento Após 7 Dias</p>
        <p>Após o prazo legal de arrependimento:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>Não haverá reembolso proporcional, salvo disposição específica do plano contratado;</li>
          <li>O acesso permanecerá ativo até o final do ciclo já pago.</li>
        </ul>

        <p className="font-bold text-slate-900 dark:text-slate-100">5.3 Acesso aos Dados Após Cancelamento ou Expiração da Conta</p>
        <p>Mesmo em caso de cancelamento, expiração ou bloqueio da assinatura, o usuário poderá acessar o aplicativo exclusivamente para:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>Visualizar seus dados em modo leitura;</li>
          <li>Realizar a exportação de seus dados descriptografados.</li>
        </ul>
        <p>Esse acesso dependerá da confirmação da senha mestre ou chave de recuperação criada pelo próprio usuário e da manutenção da planilha gerada pelo aplicativo na conta Google do usuário.</p>
        <p>O acesso para fins de exportação será disponibilizado pelo prazo de até 3 (três) meses após o cancelamento ou expiração. Após esse período, a conta poderá ser permanentemente excluída do sistema.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">6. Limitação de Responsabilidade</p>
        <p>O Equilibra Finanças não se responsabiliza por:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>Perdas financeiras ou decisões tomadas com base nos dados registrados;</li>
          <li>Perda da chave criptográfica ou exclusão acidental da planilha pelo usuário.</li>
        </ul>

        <p className="font-bold text-slate-900 dark:text-slate-100">6.1 Segurança Criptográfica e Prevenção a Uso Indevido</p>
        <p>O Equilibra Finanças utiliza arquitetura de criptografia individualizada por conta. Cada conta gera chaves criptográficas únicas e aleatórias de forma independente.</p>
        <p>Dessa forma:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li>A chave criptográfica é vinculada exclusivamente à conta original em que foi gerada.</li>
          <li>A recriação de uma conta, mesmo com o mesmo e-mail ou senha, não permitirá acesso a dados de outra conta.</li>
        </ul>
        <p>Caso seja identificado comportamento abusivo, o Equilibra Finanças poderá suspender ou cancelar as contas envolvidas e adotar medidas legais cabíveis.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">7. Propriedade Intelectual</p>
        <p>O código-fonte, design e identidade visual do Equilibra Finanças são protegidos por direitos autorais. É proibida a reprodução ou redistribuição sem autorização.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">Dúvidas ou Comentários?</p>
        <p>Contato: <code>contato@equilibrafinance.com.br</code></p>
      </div>
    )
  },
  privacy: {
    title: "Política de Privacidade",
    text: (
      <div className="space-y-4 text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
        <p className="font-bold text-slate-900 dark:text-slate-100">Equilibra Finanças</p>
        <p>Última atualização: 22 de fevereiro de 2026</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">1. Sobre o Equilibra Finanças</p>
        <p>O Equilibra Finanças é um aplicativo web (PWA) de organização financeira que utiliza integração com serviços da Google para armazenamento e organização de dados. Operamos de forma descentralizada: todos os seus dados financeiros são armazenados exclusivamente na sua própria conta Google.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">2. Dados Coletados</p>
        <p><strong>Dados de Identificação:</strong> Nome e e-mail (via autenticação Google) e um hash técnico de identificação.</p>
        <p><strong>Segurança:</strong> Armazenamos um validador hash da sua chave criptográfica (nunca a chave em texto aberto ou sua senha).</p>
        <p><strong>Dados Técnicos:</strong> Coletamos automaticamente IP, tipo de navegador e horários de acesso exclusivamente para segurança, prevenção a fraudes e validação de assinatura.</p>
        
        <p><strong>O que NÃO coletamos:</strong> Não temos acesso aos seus dados financeiros, informações bancárias, senhas, conteúdo geral do seu Google Drive ou eventos do seu calendário que não foram criados pelo próprio app.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">3. Uso de Dados do Google (Google User Data)</p>
        <p>O uso de informações recebidas das APIs do Google pelo Equilibra Finanças aderirá à <a href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes" target="_blank" className="text-blue-600 underline">Política de Dados do Usuário dos Serviços de API do Google</a>, incluindo os requisitos de Uso Limitado.</p>
        <ul className="list-disc ml-5 space-y-1">
          <li><strong>Google Drive:</strong> Utilizamos o escopo <code>drive.file</code>, o que significa que o app só pode acessar, ler e escrever no arquivo (planilha) que ele mesmo criou.</li>
          <li><strong>Google Sheets:</strong> Utilizado para gravar suas movimentações de forma estruturada.</li>
          <li><strong>Google Calendar:</strong> Utilizado apenas para inserir lembretes de pagamento quando você solicita.</li>
        </ul>

        <p className="font-bold text-slate-900 dark:text-slate-100">4. Armazenamento e Criptografia</p>
        <p>Seus dados são criptografados localmente no seu navegador antes de serem enviados para a sua planilha no Google Sheets. Adotamos uma arquitetura <strong>Zero Knowledge</strong>: o desenvolvedor não possui meios técnicos para visualizar ou descriptografar seus dados.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">5. Compartilhamento de Dados</p>
        <p>Não vendemos ou comercializamos seus dados. O compartilhamento ocorre apenas com:</p>
        <ul className="list-disc ml-5 space-y-1">
          <li><strong>Mercado Pago:</strong> Apenas dados necessários para processamento de assinatura (nome, e-mail, valor).</li>
          <li><strong>Google:</strong> Para armazenamento dos dados na sua própria conta.</li>
        </ul>

        <p className="font-bold text-slate-900 dark:text-slate-100">6. Seus Direitos (LGPD)</p>
        <p>Você possui total controle sobre seus dados, podendo acessar, corrigir ou excluir informações. Como os dados estão na sua conta Google, você pode excluir a planilha ou revogar o acesso do app a qualquer momento nas configurações de segurança da sua Conta Google.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">7. Responsabilidade e Custódia</p>
        <p>A custódia da chave criptográfica é de inteira responsabilidade do usuário. Não gravamos senhas ou cópias da chave mestre.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">8. Como Revogar o Acesso do Aplicativo</p>
        <p>O usuário pode revogar as permissões concedidas ao Equilibra Finanças a qualquer momento seguindo estes passos:</p>
        <ol className="list-decimal ml-5 space-y-1">
          <li>Acesse sua <strong>Conta Google</strong> (myaccount.google.com).</li>
          <li>No painel de navegação à esquerda, selecione <strong>Segurança</strong>.</li>
          <li>Role até a seção <strong>Suas conexões com apps e serviços de terceiros</strong> e selecione <strong>Ver todas as conexões</strong>.</li>
          <li>Localize e selecione o <strong>Equilibra Finanças</strong> na lista.</li>
          <li>Clique em <strong>Excluir todas as conexões que você tem com o app Equilibra Finanças</strong>.</li>
          <li>Confirme a ação clicando em <strong>Confirmar</strong>.</li>
        </ol>
        <p>Após a revogação, o aplicativo perderá o acesso à sua planilha e ao seu calendário imediatamente.</p>

        <p className="font-bold text-slate-900 dark:text-slate-100">9. Alterações</p>
        <p>Esta política pode ser atualizada periodicamente. Recomendamos a revisão regular deste documento.</p>
      </div>
    )
  }
};
